/**
 * Hey Tasky brand mark: the sticky-note logo (`/public/logo.png`).
 * The image already contains the "Hey Tasky" wordmark + smiley, so `Wordmark`
 * renders the image on its own rather than pairing a mark with separate text.
 */

export function Logo({ size = 36 }: { size?: number }) {
  return (
    <img
      src="/logo.png"
      alt="Hey Tasky"
      width={size}
      height={size}
      className="rounded-[5px] object-contain"
      style={{ width: size, height: size }}
    />
  )
}

export function Wordmark({ size = 22 }: { size?: number }) {
  // The logo art is square and already spells out "Hey Tasky".
  const box = size * 2.6
  return (
    <img
      src="/logo.png"
      alt="Hey Tasky"
      className="object-contain"
      style={{ width: box, height: box }}
    />
  )
}
